import React, { useRef, useState } from 'react';
import { toast } from 'sonner';
import { ImagePlus, Loader2 } from 'lucide-react';
import { adminApi, errorApi, imgSrc } from './tiendaAdminApi';

const MAX_LADO = 1600;

const reducir = (archivo) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => {
    const escala = Math.min(1, MAX_LADO / Math.max(img.width, img.height));
    const lienzo = Object.assign(document.createElement('canvas'), { width: Math.round(img.width * escala), height: Math.round(img.height * escala) });
    lienzo.getContext('2d').drawImage(img, 0, 0, lienzo.width, lienzo.height);
    URL.revokeObjectURL(img.src);
    const tipo = archivo.type === 'image/png' ? 'image/png' : 'image/jpeg';
    lienzo.toBlob(b => (b ? resolve({ blob: b, nombre: tipo === 'image/png' ? 'imagen.png' : 'imagen.jpg' }) : reject(new Error('sin datos'))), tipo, 0.88);
  };
  img.onerror = reject;
  img.src = URL.createObjectURL(archivo);
});

export default function SubirImagen({ url, onCambiar, testId, alto = 'aspect-square' }) {
  const entrada = useRef(null);
  const [subiendo, setSubiendo] = useState(false);

  const elegir = async (e) => {
    const archivo = e.target.files?.[0];
    e.target.value = '';
    if (!archivo) return;
    if (!archivo.type.startsWith('image/')) { toast.error('Elige una imagen JPG, PNG o WEBP'); return; }
    setSubiendo(true);
    try {
      const { blob, nombre } = await reducir(archivo);
      const r = await adminApi.subirImagen(blob, nombre);
      onCambiar(r.data.url);
    } catch (err) {
      toast.error(errorApi(err, 'No se pudo subir la imagen'));
    } finally {
      setSubiendo(false);
    }
  };

  return (
    <div className="space-y-2">
      <button type="button" onClick={() => entrada.current?.click()} disabled={subiendo}
        className={`group relative flex w-full items-center justify-center overflow-hidden rounded-lg border border-dashed border-slate-300 bg-slate-100 ${alto}`} data-testid={`${testId}-boton`}>
        {url && <img src={imgSrc(url)} alt="" className="h-full w-full object-contain p-2" data-testid={`${testId}-vista`} />}
        <span className={`absolute inset-0 flex flex-col items-center justify-center gap-1 text-xs font-medium transition-opacity ${url ? 'bg-black/50 text-white opacity-0 group-hover:opacity-100' : 'text-slate-500'}`}>
          {subiendo ? <Loader2 className="h-5 w-5 animate-spin" /> : <ImagePlus className="h-5 w-5" />}
          {subiendo ? 'Subiendo…' : url ? 'Reemplazar imagen' : 'Cargar imagen'}
        </span>
      </button>
      <input ref={entrada} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={elegir} data-testid={`${testId}-input`} />
    </div>
  );
}
